import ApplicationCountry from '../ApplicationCountry'
import SidebarMenuToggle from '../bones/SidebarMenuToggle'
import MenuLogout from './MenuLogout/MenuLogout'
import MenuSection from './MenuSection/MenuSection'
import useRedesignedSidebarMenu from './useRedesignedSidebarMenu'
import { StyledMenuFooterSpacer } from './styled-components'

interface RedesignedSidebarMenuProps {
  isAdmin: boolean
  isSelectraAdmin: boolean
  error: boolean
  applicationType: string
  expanded: boolean
  onToggle: () => void
}

const RedesignedSidebarMenu = ({
  isAdmin,
  isSelectraAdmin,
  error,
  applicationType,
  expanded,
  onToggle,
}: RedesignedSidebarMenuProps) => {
  const { sections, logout, country, fill } = useRedesignedSidebarMenu({
    isAdmin,
    isSelectraAdmin,
    error,
    applicationType,
  })

  return (
    <>
      <SidebarMenuToggle expanded={expanded} onToggle={onToggle} />
      {sections.map(section => (
        <MenuSection key={section.key} section={section} expanded={expanded} fill={fill} />
      ))}
      <StyledMenuFooterSpacer />
      <MenuLogout logout={logout} expanded={expanded} fill={fill} />
      <ApplicationCountry country={country} floating />
    </>
  )
}

export default RedesignedSidebarMenu
